export default "__VITE_ASSET__mA5V3Gwa__"